export const IconCheckboxCheckedFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath="url(#IconCheckboxCheckedFilled_svg__a)">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-8.3 13.3c-.4.4-1 .4-1.4 0l-3.6-3.6c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.9 2.9 6.9-6.9c.4-.4 1-.4 1.4 0s.4 1 0 1.4z" />
        <path
          fill="#fff"
          d="M10.7 16.3c-.4.4-1 .4-1.4 0l-3.6-3.6c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.9 2.9 6.9-6.9c.4-.4 1-.4 1.4 0s.4 1 0 1.4z"
        />
      </g>
      <defs>
        <clipPath id="IconCheckboxCheckedFilled_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
